const getters = {
  login: state => state.login
}
export default getters
